import $ from 'jquery';
import {searchCity} from '../api/api';

export default class Autocomplete {
	constructor() {

		this.selectors = {
			autocomplete: '.js-autocomplete',
			autocompleteResult: '.js-autocomplete-result',
			autocompleteResultItem: '.js-autocomplete-result-item'
		};

		this.defaults = {
			searchUrl: 'assets/json/autocomplete.json',
			success: 'OK',
			suggestTagOpen: '<b>',
			suggestTagClose: '</b>',
			resultTagOpen: '<span class="search__span">',
			resultTagClose: '</span>'

		};

		this.$autocomplete = $(this.selectors.autocomplete);
	}

	query = e => {
		const $target = $(e.target);
		searchCity($target.val()).then(this.writeResult);
	};

	getDom() {
		this.$autocompleteResult = this.$autocomplete.find(this.selectors.autocompleteResult);
		this.$autocompleteResultItemTmp = this.$autocomplete.find(this.selectors.autocompleteResultItem).eq(0).clone();
		this.$autocompleteResultItemTmp.find('a').empty();
		this.$autocompleteResult.empty();
		this.trigger = this.$autocomplete.data('trigger');
		this.$trigger = $(this.trigger);

		$('html').on('click', () => this.$autocompleteResult.hide());
	}

	writeResult = data => {
		const self = this;
		const result = data;
		if (result.status === this.defaults.success && result.suggest.length) {

			self.$autocompleteResult.empty();

			result.suggest.forEach(function (item) {
				item = item.replace(self.defaults.suggestTagOpen, self.defaults.resultTagOpen)
				.replace(self.defaults.suggestTagClose, self.defaults.resultTagClose);
				self.$autocompleteResult.append(self.createClone(item));
			});

			self.$autocompleteResult.show();
			self.$autocompleteResult.find(self.selectors.autocompleteResultItem).each((i, item) => {
				$(item).find('a').on('click', self.setResultItem.bind(self));
			});
		}
	};

	createClone(data) {
		const clone = this.$autocompleteResultItemTmp.clone();
		clone.find('a').append(data);
		return clone;
	}

	setResultItem(e) {
		const $target = e.currentTarget;
		this.$autocomplete.find('input').val($target.textContent);
		this.$autocompleteResult.hide();
		this.$trigger.trigger('choose', [$target.textContent]);
	}


	render() {
		if (this.$autocomplete.length) {
			this.$autocomplete.find('input').on('keydown', this.query);
			this.getDom();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/autocomplete/autocomplete.js
 **/